// store/slices/heroSlice.ts
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { REQUEST_STATUSES, HOST, } from "common/constants";
import { addQueryCases } from "common/helpers";

// Можно сделать переменной, но сейчас оставим как есть
const ENDPOINT = `${HOST}/api/v1/hero-image/`;

export const getHeroSlides = createAsyncThunk(
  "hero/getHeroSlides",
  async (_, { extra: api }) => {
    const res = await api.get(ENDPOINT);
    return res.data.results?.[0]?.images || [];
  }
);

const initialState = {
  slides: [],
  slidesStatus: REQUEST_STATUSES.NOT_REQUESTED,
  slidesError: null,
};

const heroSlice = createSlice({
  name: "hero",
  initialState,
  reducers: {},
  extraReducers(builder) {
    addQueryCases(builder, getHeroSlides, {
      status: "slidesStatus",
      data: "slides",
      error: "slidesError",
    });
  },
});

export default heroSlice;
